import type { ShopMessageKey } from '../../i18n'
import type { CheckoutFlowState } from './CheckoutFlow.types'
import { useCheckoutFlowEffects } from './useCheckoutFlowEffects'
import { useCheckoutFlowReducer } from './useCheckoutFlowReducer'
import { useCheckoutSubmitHandlers } from './useCheckoutSubmitHandlers'
import { useCheckoutViewModel } from './useCheckoutViewModel'

export type { CheckoutAddressForm, CheckoutFlowAction, CheckoutFlowState } from './CheckoutFlow.types'
export { useCheckoutFlowEffects, useCheckoutFlowReducer, useCheckoutSubmitHandlers, useCheckoutViewModel }

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

export const useCheckoutFlow = ({
  token,
  authenticated,
  authInitializing,
  cartId,
  cartInitializing,
  toLocalizedPath,
  formatCurrency,
  t,
  onCheckoutCompleted,
}: {
  token: string | null
  authenticated: boolean
  authInitializing: boolean
  cartId: string | null
  cartInitializing: boolean
  toLocalizedPath: (path: string) => string
  formatCurrency: (value: number) => string
  t: TranslateFn
  onCheckoutCompleted: (consumedCartId: string) => Promise<void>
}) => {
  const [state, dispatch] = useCheckoutFlowReducer()

  useCheckoutFlowEffects({
    state,
    dispatch,
    token,
    authenticated,
    authInitializing,
    cartId,
    cartInitializing,
    toLocalizedPath,
    onCheckoutCompleted,
  })

  const submitHandlers = useCheckoutSubmitHandlers({
    state,
    dispatch,
    token,
    toLocalizedPath,
    t,
    onCheckoutCompleted,
  })

  const viewModel = useCheckoutViewModel({
    state,
    dispatch,
    formatCurrency,
    t,
    submitHandlers,
  })

  return {
    state: state as CheckoutFlowState,
    dispatch,
    submitHandlers,
    viewModel,
  }
}
